export enum ZoomableObjectTypes {
  BOUNDS = 'BOUNDS',
  POINT = 'POINT',
}
